import React from 'react';
import LeaderboardEntry from './LeaderboardEntry';
import './LeaderboardTable.css';

const LeaderboardTable = ({ entries, currentUser, onRefresh }) => {
  if (!entries || entries.length === 0) {
    return (
      <div className="leaderboard-empty">
        <p>No leaderboard entries to display</p>
      </div>
    );
  }

  return (
    <div className="leaderboard-table-container">
      <div className="leaderboard-table">
        {/* Table header */}
        <div className="leaderboard-header-row">
          <div className="rank-column">Rank</div>
          <div className="user-column">User</div>
          <div className="tasks-column">Tasks Solved</div>
        </div>

        {/* Table body */}
        <div className="leaderboard-body">
          {entries.map((entry, index) => (
            <LeaderboardEntry
              key={`${entry.user_id}-${entry.rank}`}
              entry={entry}
              index={index}
              isCurrentUser={currentUser && currentUser.id === entry.user_id}
            />
          ))}
        </div>
      </div>

      {/* Table footer with summary info */}
      <div className="leaderboard-footer">
        <div className="entry-count">
          Showing {entries.length} entries
        </div>

        {/* Tied ranks explanation */}
        {entries.some(entry => entry.tied_rank) && (
          <div className="tied-ranks-info">
            <span className="info-icon">ℹ️</span>
            Users with the same number of solved tasks are ordered alphabetically
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaderboardTable;